export const ACME_INSURANCE_RENEWAL_MONDAY_TRIGGER_USER_PROMPT =
  'Great. Send me an updated version every Monday morning.'

export const ACME_INSURANCE_RENEWAL_MONDAY_TRIGGER_TITLE = 'Weekly Acme Insurance brief'

export const ACME_INSURANCE_RENEWAL_MONDAY_TRIGGER_SCHEDULE = 'Every Monday at 8:00 AM'

export const ACME_INSURANCE_RENEWAL_MONDAY_TRIGGER_CONFIRMATION =
  "Done. I'll refresh the Acme Insurance brief every Monday at 8:00 AM and email it to you. I renamed this agent **Weekly Acme Insurance brief** so it's easy to find."

export const ACME_INSURANCE_RENEWAL_MONDAY_TRIGGER_WORKED_LABEL = 'Worked for 2s'

/** @returns {object[]} */
export function buildAcmeInsuranceRenewalMondayTriggerBlocks() {
  return [
    {
      type: 'createdTrigger',
      title: ACME_INSURANCE_RENEWAL_MONDAY_TRIGGER_TITLE,
      schedule: ACME_INSURANCE_RENEWAL_MONDAY_TRIGGER_SCHEDULE,
    },
    {
      type: 'markdown',
      content: ACME_INSURANCE_RENEWAL_MONDAY_TRIGGER_CONFIRMATION,
    },
  ]
}
